import gql from 'graphql-tag'

export const getAcademyRootCategoriesQuery = gql`
  query DooerGetAcademyRootCategories($filter: String) {
    academy {
      articles(first: 5000, filter: $filter) {
        totalCount
        edges {
          node {
            id
            description
            title
            icon
            slug
            markdown {
              source
            }
            category {
              id
              title
              icon
              slug
              customerCategories
            }
            customerCategories
          }
        }
      }

      treeCategories(filter: $filter) {
        totalCount
        edges {
          # cursor
          node {
            id
            targets
            customerCategories
            slug
            description
            title
            icon
            articles(tree: true, first: -1, filter: $filter) {
              totalCount
              edges {
                node {
                  id
                  slug
                  markdown {
                    source
                  }

                  icon
                  title
                  customerCategories
                }
              }
            }
            children(filter: $filter) {
              totalCount
              edges {
                node {
                  id
                  targets
                  customerCategories
                  slug
                  description
                  title
                  icon
                  articles(tree: true, first: -1, filter: $filter) {
                    totalCount
                    edges {
                      node {
                        id
                        slug
                        markdown {
                          source
                        }

                        icon
                        title
                        customerCategories
                      }
                    }
                  }
                  children(filter: $filter) {
                    totalCount
                    edges {
                      node {
                        id
                        targets
                        customerCategories
                        slug
                        description
                        title
                        icon
                        articles(tree: true, first: -1, filter: $filter) {
                          totalCount
                          edges {
                            node {
                              id
                              slug
                              markdown {
                                source
                              }

                              icon
                              title
                              customerCategories
                            }
                          }
                        }
                        children(filter: $filter) {
                          totalCount
                          edges {
                            node {
                              id
                              targets
                              customerCategories
                              slug
                              description
                              title
                              icon
                              articles(tree: true, first: -1, filter: $filter) {
                                totalCount
                                edges {
                                  node {
                                    id
                                    slug
                                    markdown {
                                      source
                                    }

                                    icon
                                    title
                                    customerCategories
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
